// @flow

export const styles = {
  container: {
    background: '#2F3755'
  },
  padding: {
    padding: 40
  },
  paragraph: {
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    fontSize: 18,
    color: 'white',
    lineHeight: '30px',
    textShadow: '0 2px 2px rgba(47,55,85,0.10)'
  },
  button: {
    background: '#FFF378',
    borderRadius: '100px',
    minWidth: 170,
    minHeight: 40,
    border: 0,
    padding: 0,
    cursor: 'pointer',
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 600,
    fontSize: 14,
    color: 'black'
  }
}



// WEBPACK FOOTER //
// ./src/layouts/Styles/CTASection.Style.js